import Vue from 'vue'
import Router from 'vue-router'
import store from '@/services/store'

import PublicLayout from '@/views/Public/Layout'
import PrivateLayout from '@/views/Private/Layout'

import PublicRoutes from '@/routes/publicRoutes'
import PrivateRoutes from '@/routes/privateRoutes'

Vue.use(Router)

let router = new Router({
	mode: 'history',
	scrollBehavior: function (to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 }
	},
	routes: [
		{
			path: '/',
			component: PublicLayout,
			children: PublicRoutes
		},
		{
			path: '/',
			component: PrivateLayout,
			children: PrivateRoutes,
			meta: { requiresAuth: true }
		}
	]
})

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
	if (requiresAuth && !store.state.auth.access_token) {
		next('/login')
		return
	}
	next()
})

export default router
